import React from "react";
import Reveal from "../components/Reveal";
import PageSeo from "../components/PageSeo";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SiteSettingsContext";

export default function AboutPage() {
  const { t, lang } = useLang();
  const settings = useSettings();

  const seoTitle = lang === "en" ? settings.about_meta_title_en : settings.about_meta_title_it;
  const seoDesc = lang === "en" ? settings.about_meta_desc_en : settings.about_meta_desc_it;

  return (
    <div className="pt-32 pb-24 lg:pb-40 bg-[#09090b] min-h-screen" data-testid="about-page">
      <PageSeo title={seoTitle} description={seoDesc} pathIt="/it/chi-siamo" pathEn="/en/about" />
      <div className="container-x">
        <Reveal>
          <div className="overline mb-4">{t.about.overline}</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1] max-w-3xl">
            {t.about.title.split("\n").map((l, i) => (<span key={l || `ap-line-${i}`} className="block">{l}</span>))}
          </h1>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-12 gap-12 lg:gap-16">
          <Reveal className="lg:col-span-6" delay={0.1}>
            <div className="aspect-[4/5] overflow-hidden border border-white/10">
              <img
                src="/images/hotel-exterior.png"
                alt="Hotel"
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
          <Reveal className="lg:col-span-6 flex flex-col justify-center" delay={0.15}>
            <p className="text-2xl font-serif text-white/90 leading-relaxed mb-8">{t.about.p1}</p>
            <p className="text-white/60 leading-relaxed">{t.about.p2}</p>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
